import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { batchType, batchApplyStatus } from '@/constants/coupon';
export default {
  name: 'coupon-item',
  props: {
    batchInfo: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      batchType: batchType,
      batchApplyStatus: batchApplyStatus,
      timeStr: '',
      showDetial: false
    };
  },
  mounted: function mounted() {
    this.controlCountDown(this.batchInfo.endTimeInfo.endTimeType, this.batchInfo.voucherEndTime);
  },
  beforeDestroy: function beforeDestroy() {
    this.stopCount();
  },
  computed: {
    showText: function showText() {
      return this.batchInfo.userCount > 0 ? '继续领取' : '立即领取';
    },
    showMaxText: function showMaxText() {
      return this.batchInfo.discountValue.toString().length > 4;
    }
  },
  methods: {
    receiveCoupon: function receiveCoupon() {
      this.$emit('receiveCoupon', this.batchInfo.activityId);
    },
    showRule: function showRule() {
      this.showDetial = !this.showDetial;
    },
    countDown: function countDown(endTime, liveCallback, endCallback) {
      var _this = this;
      var callback = function callback() {
        var remain = Math.floor((endTime - Date.now()) / 1000);
        if (remain < 0 || isNaN(remain)) {
          _this.stopCount();
          return endCallback();
        }
        var h = "".concat(Math.floor(remain / 3600));
        var m = "".concat(Math.floor(remain % 3600 / 60));
        var s = "".concat(remain % 60);
        liveCallback(h, m, s);
      };
      callback();
      this.stopCount();
      this.timeID = setInterval(callback, 1000);
    },
    stopCount: function stopCount() {
      if (this.timeID) {
        clearInterval(this.timeID);
      }
    },
    // 控制倒计时展示
    controlCountDown: function controlCountDown(endTimeType, voucherEndTime) {
      var _this2 = this;
      if (endTimeType === 3) {
        var payEndTime = voucherEndTime;
        this.countDown(payEndTime, function (h, m, s) {
          if (h !== '0') {
            _this2.timeStr = "".concat(h, "\u5C0F\u65F6").concat(m, "\u5206\u949F\u540E\u5230\u671F");
          } else {
            _this2.timeStr = "".concat(m, "\u5206\u949F").concat(s, "\u79D2\u540E\u5230\u671F");
          }
        }, function () {
          // 倒计时结束刷新优惠券 
          _this2.$emit('changeCouponStatus');
        });
      }
    }
  },
  watch: {
    batchInfo: {
      handler: function handler(val) {
        this.controlCountDown(val.endTimeInfo.endTimeType, val.voucherEndTime);
      },
      deep: true
    }
  }
};